export class EnvService {
  public environment: any = {};
  public authConfig: any = {};
  public discoveryDocumentConfig: any = {};
  public enableDebug: boolean = true;

  constructor() {
  }
}
